import { render, staticRenderFns } from "./gateWay.vue?vue&type=template&id=5bb5633e&scoped=true&"
import script from "./gateWay.vue?vue&type=script&lang=js&"
export * from "./gateWay.vue?vue&type=script&lang=js&"
import style0 from "./gateWay.vue?vue&type=style&index=0&id=5bb5633e&prod&lang=scss&scoped=true&"
import style1 from "./gateWay.vue?vue&type=style&index=1&id=5bb5633e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb5633e",
  null
  
)

export default component.exports